import React, { useEffect, useRef, useState } from 'react'
import { ZdsCheckbox } from '@zera/components'
import { Selection, FilterButton } from './styles'
import { AlertMessage } from '~/components/shared'
import { useLaboratoryHealthProcedures } from '~/context'
import { IconComponent } from '~/assets/icons/component'
import { message } from '~/services'

const FilterByOrganisms: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>(null)
  const { displayedUrineCulture, isLoading, setterSelectedOrganisms, selectedOrganisms } =
    useLaboratoryHealthProcedures()
  const [selectionOpen, setSelectionOpen] = useState<boolean>(false)

  const organisms = displayedUrineCulture
    .reduce((acc, curr) => {
      const { organism, organismGrowth } = curr
      const differentOrganisms = organism?.filter(name => !acc.find(_data => _data === name))

      if (differentOrganisms && organismGrowth === 'POSITIVO') {
        acc.push(...differentOrganisms)
      }
      return acc
    }, [] as string[])
    .sort()

  const handleSelectFilter = (name: string) => {
    if (selectedOrganisms.includes(name)) {
      setterSelectedOrganisms(selectedOrganisms.filter(key => key !== name))
      return
    }
    setterSelectedOrganisms([...selectedOrganisms, name])
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (contentRef.current && !contentRef.current.contains(event.target as Node)) {
        setSelectionOpen(false)
      }
    }
    const handleCloseWithKeyboard = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        setSelectionOpen(false)
      }
    }

    if (selectionOpen) {
      document.addEventListener('click', handleClickOutside)
      document.addEventListener('keydown', handleCloseWithKeyboard)
    }

    return () => {
      document.removeEventListener('keydown', handleCloseWithKeyboard)
      document.removeEventListener('click', handleClickOutside)
    }
  }, [selectionOpen])

  return (
    <div ref={contentRef}>
      <FilterButton
        data-testid={'buttonOrganisms'}
        width="150px"
        disabled={displayedUrineCulture?.length === 0}
        isLoading={isLoading}
        onClick={() => setSelectionOpen(prev => !prev)}
      >
        <IconComponent name="covidVirus" />
        <span>{message('laboratory.organisms')}</span>
      </FilterButton>

      {organisms && organisms.length > 0 ? (
        <Selection data-testid="selectionOrganismsContainer" open={selectionOpen}>
          <ul>
            {organisms.map(organism => (
              <li key={organism}>
                <ZdsCheckbox
                  onChange={() => handleSelectFilter(organism)}
                  checked={selectedOrganisms.includes(organism)}
                  label={organism}
                />
              </li>
            ))}
          </ul>
        </Selection>
      ) : (
        <Selection open={selectionOpen}>
          <AlertMessage>{message('laboratory.organism_empty_message')}</AlertMessage>
        </Selection>
      )}
    </div>
  )
}

export { FilterByOrganisms }
